import { TimeOccurrenceServant } from '../servants/time/time_occurrence_servant';
import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { IValidation, IValidator } from './contracts';

angular.module('ui-ng-calendar').factory('timeLockValidatorFactory', function () {
  return (originalTimeOccurrence: ITimeOccurrenceDatatype): IValidator =>
    function timeLockValidator(store: ITimeOccurrenceDatatype[]): IValidation {
      return {
        isValid: !originalTimeOccurrence.isLocked
      };
    };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/validation/time_lock_validator.ts